export default __webpack_public_path__ + "static/media/threeDots.5cd86537.svg";